<template>
  <div class="picmanagetable">
    <el-table :data="tableData"
              style="width: 100%; padding: 10px 10px 0 10px"
              border>
      <el-table-column prop="id"
                       label="图集id"
                       width="80">
        <template slot-scope="scope">
          <span class="spanId">{{scope.row.id}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createAtMY"
                       label="创建日期"
                       width="160">
        <!-- <template slot-scope="scope">
          <span>{{formatConversion(scope.row.createAt)}}</span>
        </template> -->
      </el-table-column>
      <el-table-column prop="status"
                       width="80"
                       label="状态">
        <template slot-scope="scope">
          <div v-if="scope.row.status == 0">
            <el-tag type="info">{{ "草稿" }}</el-tag>
          </div>

          <div v-if="scope.row.status == 1">
            <el-tag type="success">{{ "已发布" }}</el-tag>
          </div>

          <div v-if="scope.row.status == 2">
            <el-tag>{{ "定时发布" }}</el-tag>
          </div>
        </template>
      </el-table-column>

      <el-table-column prop="title"
                       label="标题"> </el-table-column>

      <el-table-column prop="picLength"
                       label="图片数"> 
        <template slot-scope="scope">
          <span @click="seePic(scope)" style="color:#137FFE;cursor: pointer;">{{scope.row.picLength}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createName"
                       label="发布人"> </el-table-column>

      <el-table-column v-if="powersObj.manageWebsiteInfo"
                       label="操作"
                       width="350">
        <template slot-scope="scope">
          <div id="eltable">
            <!-- <el-button
            @click="reCallClick(scope)"
            v-if="scope.row.status === 1"
            style="color: #f96900; font-weight: bold; font-size: 13px"
            type="text"
            class="btn"
            size="small"
            ><i style="margin-right: 3px" class="el-icon-circle-close"></i
            >撤回</el-button
          > -->
            <!-- <el-button
            @click="releaseClick(scope)"
            v-if="scope.row.status == 0"
            style="color: #13aa65; font-weight: bold; font-size: 13px"
            type="text"
            class="btn"
            size="small"
            ><i style="margin-right: 3px" class="el-icon-document-checked"></i
            >发布</el-button
          > -->
            <!-- <span v-if="scope.row.status === 0 || scope.row.status === 1" style="margin: 0 11px"> | </span>
          <el-button
            @click="changeClick(scope)"
            style="color: #185ed3; font-weight: bold; font-size: 13px"
            type="text"
            class="btn"
            size="small"
            ><i style="margin-right: 3px" class="el-icon-edit-outline"></i
            >修改</el-button
          > -->
            <el-button @click="sortClick(scope)"
                       style="color: #185ed3; font-weight: bold; font-size: 13px"
                       type="text"
                       class="btn"
                       size="small"><i style="margin-right: 3px"
                 class="el-icon-s-fold"></i>排序</el-button>
            <span style="margin: 0 11px"> | </span>
            <el-button @click="notRecommendClick(scope)"
                       style="color: #185ed3; font-weight: bold; font-size: 13px"
                       type="text"
                       class="btn"
                       size="small"><i style="margin-right: 3px"
                 class="el-icon-download"></i>取消推荐</el-button>

            <!-- <span style="margin: 0 11px"> | </span>
          <el-button
            @click="removeClick(scope)"
            style="color: #ff4545; font-weight: bold; font-size: 13px"
            type="text"
            class="btn"
            size="small"
            ><i style="margin-right: 3px" class="el-icon-delete"></i
            >删除</el-button
          > -->
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
// import { getDate,formatConversion } from "@/plugins/getdate";
import { powersObj } from "@/constants/powers";
import Sortable from "sortablejs";
import {
  updateWebsiteShowInfo,
} from "@/api/website";

export default {
  name: "picmanagetable",
  props: {
    tableData: Array,
  },

  data () {
    return {
      powersObj,
    };
  },
  mounted () {
    this.rowDrop()
    console.log(this.tableData);
  },
  methods: {
    //行拖拽
    rowDrop () {
      //获取对象
      var el = document.querySelector('.el-table__body-wrapper tbody')
      //设置配置
      let _this = this
      var ops = {
        animation: 1000,
        //拖动结束
        onEnd: function (evt) {
          console.log(evt.item);
          //获取拖动后的排序
          var arr = sortable.toArray();
          console.log(_this.tableData);
          console.log(document.getElementsByClassName('spanId'));
          // alert(JSON.stringify(arr));
          let dataList = document.getElementsByClassName('spanId')
          for (let i = 0; i < dataList.length; i++) {
            console.log(dataList[i].innerHTML);

            for (let j = 0; j < _this.tableData.length; j++) {
              if (dataList[i].innerHTML == _this.tableData[j].id) {
                _this.tableData[j].sort = Math.abs(i - _this.tableData.length)
                break;
              }
            }
          }
          for (let m = 0; m < _this.tableData.length; m++) {
            _this.updateWebsiteShowInfoAsync(_this.tableData[m])

          }
          console.log(_this.tableData);
        },
      };
      //初始化
      var sortable = Sortable.create(el, ops);
    },
    async updateWebsiteShowInfoAsync (val) {
      let { status, data } = await updateWebsiteShowInfo(val);
      if (status) {

      }
    },
    notRecommendClick (scope) {
      console.log(scope);
      scope.isrecommend = true
      this.$emit("notRecommendClick", scope);
    },
    //修改
    changeClick (scope) {
      this.$emit("changeClick", scope);
    },

    //删除
    removeClick (scope) {
      this.$emit("removeClick", scope);
    },
    //撤回
    reCallClick (scope) {
      this.$emit("reCallClick", scope);
    },
    //发布
    releaseClick (scope) {
      this.$emit("releaseClick", scope);
    },

    //推荐
    sortClick (scope) {
      this.$emit("sortClick", scope);
    },

    //查看图片
    seePic (scope) {
      this.$emit("seePic", scope);
    },
  },
  created () { },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.table {
  width: auto;
}
.btn:hover {
  text-decoration: underline;
}
</style>
